module.exports = __webpack_public_path__ + "img/icon4.2f0d84fb.png";